/**
 * Display labels for the backend `transaction_type` enum shown in the ticket
 * History feed. Curated labels override the default; any value not listed here
 * is normalised from snake_case to Title Case by `formatTransactionType` so it
 * never renders as a raw lowercase token (e.g. `comped` → `Comped`).
 */
export const TRANSACTION_TYPE_LABELS: Record<string, string> = {
	transferred: 'Transferred',
	sale_canceled: 'Canceled',
	switched_to: 'Switched To',
	switched_from: 'Switched From',
	refunded: 'Refunded',
	primary_sold: 'Sale',
};

/**
 * Resolves a `transaction_type` enum to a consistent display label. Known enums
 * use their curated label; unknown enums are normalised snake_case → Title Case
 * so the History feed never mixes cased labels (e.g. "Sale") with raw lowercase
 * snake_case ("comped", "sale_canceled"). Safe for any future backend enum.
 */
export const formatTransactionType = (type: string): string => {
	if (!type) return '';
	if (TRANSACTION_TYPE_LABELS[type]) return TRANSACTION_TYPE_LABELS[type];
	return type
		.split(/[_\s]+/)
		.filter(Boolean)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(' ');
};
